import React, { useContext, useEffect } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import ControlGroup from "@amzn/meridian/control-group";
import {
  SWA_REVERSE_CYCLE_ID,
  SWA_REVERSE_CYCLE_NAME,
} from "./utils/Constants";
import { CycleFilterContext } from "./context/CycleFilterContext";
import {
  getCycleDataFromParent,
  getFeatureStatus,
} from "../handler/ParentDataHandler";
import { FormattedMessage } from "react-intl";
import Select, { SelectOption } from "@amzn/meridian/select";
import { useDeviceLayout } from "../common/context/DeviceLayoutContext";
import { FilterExpander } from "../common/FilterExpander";
import { FEATURES } from "../util/Constants";

const CycleFilter = () => {
  const { cycles, dispatch } = useContext(CycleFilterContext);
  const { isMobile, spacingInset_shorthand2 } = useDeviceLayout();

  const value = cycles.selectedCycles ? cycles.selectedCycles[0] : "";

  useEffect(() => {
    getCycleDataFromParent().then((cycleData) => {
      cycleData["defaultCycleFilter"] = true;
      getFeatureStatus(FEATURES.IS_SWA_REVERSE_CYCLE_ENABLED).then((res) => {
        if (res.data && res.data.isSWAReverseCycleEnabled) {
          const receivedCycleList = JSON.parse(cycleData.cycleList);
          receivedCycleList.push({
            cycleId: SWA_REVERSE_CYCLE_ID,
            casCycleId: "Reverse-CAS",
            cycleName: SWA_REVERSE_CYCLE_NAME,
          });
          let updatedCycleList = JSON.stringify(receivedCycleList);
          cycleData.cycleList = updatedCycleList;
          dispatch({ type: "INITIALIZE_CYCLES", cycleData });
        } else {
          dispatch({ type: "INITIALIZE_CYCLES", cycleData });
        }
      });
    });
  }, []);

  const CycleFilter = () => (
    <Column spacing="small" spacingInset={spacingInset_shorthand2}>
      <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
        <ControlGroup
          label={
            <FormattedMessage id="cycle_filter.cycle" defaultMessage="Cycle" />
          }
          name="cycles"
        >
          <Select
            value={cycles.selectedCycles[0]}
            onChange={(value) =>
              dispatch({ type: "SELECT_CYCLE", cycle: value })
            }
            width={150}
            placeholder={value}
            size={"small"}
          >
            {cycles.allCycles.map((cycle) => {
              return (
                <SelectOption
                  value={cycle.cycleName}
                  label={cycle.displayableName}
                />
              );
            })}
          </Select>
        </ControlGroup>
      </Row>
    </Column>
  );

  return (
    <React.Fragment>
      {isMobile ? (
        <FilterExpander>
          <CycleFilter />
        </FilterExpander>
      ) : (
        <CycleFilter />
      )}
    </React.Fragment>
  );
};

export default CycleFilter;



// WEBPACK FOOTER //
// ./src/components/overview/CycleFilterv2.js